<template>
	<div>
		<slot name="trigger" />
		<span ref="tooltip" />
		<div v-show="false">
			<div ref="content">
				<slot />
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import tippy from 'tippy.js'
import 'tippy.js/dist/border.css'
import 'tippy.js/dist/tippy.css'
import { onMounted, onUnmounted, onUpdated, ref } from 'vue'

const tooltip = ref()
const content = ref()
const tooltipInstance = ref()

// const slots = useSlots()

const props = defineProps({
	options: {
		type: Object,
		default: () => ({}),
	},
})

function destroyTooltip() {
	if (tooltipInstance.value) {
		tooltipInstance.value.destroy()
	}
}

function initTooltip() {
	destroyTooltip()
	tooltipInstance.value = tippy(tooltip.value?.parentNode, {
		content: content.value,
		theme: 'smartforest',
		arrow: true,
		allowHTML: true,
		...props.options,
	})
}

onMounted(initTooltip)
onUpdated(initTooltip)
onUnmounted(destroyTooltip)
</script>

<style>
.tippy-box[data-theme~='smartforest'] > .tippy-svg-arrow {
	fill: #fefefe;
}

.tippy-box[data-theme~='smartforest'] {
	border: inherit;
}

.tippy-box[data-theme~='smartforest'][data-placement^='top'] > .tippy-arrow::before {
	border-top-color: #fefefe;
}

.tippy-box[data-theme~='smartforest'][data-placement^='bottom'] > .tippy-arrow::before {
	border-bottom-color: #fefefe;
}

.tippy-box[data-theme~='smartforest'][data-placement^='left'] > .tippy-arrow::before {
	border-left-color: #fefefe;
}

.tippy-box[data-theme~='smartforest'][data-placement^='right'] > .tippy-arrow::before {
	border-right-color: #fefefe;
}

.tippy-box[data-theme~='smartforest'] {
	@apply bg-white-neutral !border !border-gray-medium rounded shadow-md;
}
</style>
